"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const trans_1 = require("@common/tsutils/trans");
const MapSideBarPanel_vue_1 = __importDefault(require("./MapSideBarPanel.vue"));
const axios_1 = __importDefault(require("axios"));
const ModalsSelectsModuleResults_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/ModalsSelectsModuleResults.vue"));
const SwichQR_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/SwichQR.vue"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
let MapSideBarPanelActions = class MapSideBarPanelActions extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.titleModal = '';
        this.subtitleModal = '';
        this.optionsModal = [];
        this.btnModalText = '';
        this.typeModal = '';
        this.modalOpen = false;
        this.loadingModalDeploy = false;
        this.actionActiveName = '';
        this.certificateError = '';
        this.isDeployModalExport = false;
        this.isMapScreenshot = false;
        this.isdownloadReport = false;
        this.statusVisibility = false;
    }
    mounted() {
        localStorage.setItem('QrstatusVisibility', '');
        const localVisibility = localStorage.getItem('QrstatusVisibility');
        const localVisibilityBoolean = localVisibility === 'true';
        if (localVisibility) {
            this.mainProjectDelivery.certificate.is_public = localVisibilityBoolean;
            if (localVisibilityBoolean === this.mainProjectDelivery.certificate.is_public) {
                if (localVisibility === 'true') {
                    this.statusVisibility = true;
                }
                else {
                    this.statusVisibility = false;
                }
            }
        }
        else {
            if (this.mainProjectDelivery.certificate.is_public) {
                this.statusVisibility = true;
            }
            else {
                this.statusVisibility = false;
            }
        }
    }
    resetVisibility() {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const areaId = urlObj.searchParams.get('areaId');
        const localVisibility = localStorage.getItem('QrstatusVisibility');
        const localVisibilityBoolean = localVisibility === 'true';
        if (areaId === this.mainProjectDelivery.meta.area_id.toString()) {
            if (localVisibility && localVisibilityBoolean === this.mainProjectDelivery.certificate.is_public) {
                if (localVisibility === 'true') {
                    this.statusVisibility = true;
                }
                else {
                    this.statusVisibility = false;
                }
            }
            else {
                if (this.mainProjectDelivery.certificate.is_public) {
                    this.statusVisibility = true;
                }
                else {
                    this.statusVisibility = false;
                }
            }
        }
    }
    get projectMain() {
        return this.mainProjectDelivery;
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get sampleCodesCurrentProject() {
        var _a;
        return (_a = this.mainProjectDelivery) === null || _a === void 0 ? void 0 : _a.samples.map((s) => s.code);
    }
    get sampleCodesCurrentProjectSecondary() {
        var _a;
        return (_a = this.secondarySingleProjectDelivery) === null || _a === void 0 ? void 0 : _a.samples.map((s) => s.code);
    }
    async toggleVisibilityProject(id) {
        try {
            await axios_1.default.get('/rate/' + id + '/setIsPublished');
        }
        catch (e) {
            this.toggleVisibilityResponse = e.response.data.message;
            this.statusVisibility = null;
        }
        this.statusVisibility = !this.statusVisibility;
        localStorage.setItem('QrstatusVisibility', this.statusVisibility.toString());
        this.mainProjectDelivery.certificate.is_public = this.statusVisibility;
        if (this.statusVisibility) {
            this.toggleVisibilityResponse = (0, trans_1.trans)('tracking.set_pub_success');
        }
        else {
            this.toggleVisibilityResponse = (0, trans_1.trans)('tracking.set_priv_success');
        }
    }
    get typeProjectSelected() {
        if (this.mainProjectDelivery) {
            return this.mainProjectDelivery.meta.type;
        }
        return 'rate';
    }
    downloadReport() {
        this.$emit('downloadReport', !this.isdownloadReport);
    }
    mapScreenshot(value) {
        this.isMapScreenshot = value;
        this.$emit('isMapScreenshot', this.isMapScreenshot);
    }
    deployModalExport() {
        this.isDeployModalExport = true;
    }
    dismissModalExport() {
        this.isDeployModalExport = false;
    }
    deployModal(title, subtitle, options, btn, type) {
        this.titleModal = title;
        this.subtitleModal = subtitle;
        this.optionsModal = options;
        this.btnModalText = btn;
        this.typeModal = type;
        this.modalOpen = true;
    }
    dismissModal() {
        this.modalOpen = false;
        this.actionActiveName = '';
    }
    async triggerActionFromModal() {
        this.loadingModalDeploy = true;
        if (this.titleModal === 'Download Certificate') {
            try {
                // eslint-disable-next-line no-unused-vars
                const call = fetch('/data/results/certificate/' + this.mainProject.area_id).then((response) => {
                    if (response.status === 200) {
                        window.open('/data/results/certificate/' + this.mainProject.area_id, '_blank');
                    }
                    else {
                        this.certificateError = "You don't own this report!";
                    }
                });
            }
            catch (error) {
                console.log(error);
            }
        }
        this.loadingModalDeploy = false;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'single' })
], MapSideBarPanelActions.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelActions.prototype, "mainProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelActions.prototype, "secondaryProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelActions.prototype, "metric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], MapSideBarPanelActions.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapSideBarPanelActions.prototype, "isBiome", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelActions.prototype, "mainProjectDelivery", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: (Array), default: [] })
], MapSideBarPanelActions.prototype, "mainProjectsList", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: (Array), default: [] })
], MapSideBarPanelActions.prototype, "secondaryProjectsList", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: (Array), default: [] })
], MapSideBarPanelActions.prototype, "compositableProjects", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelActions.prototype, "secondarySingleProjectDelivery", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('projectMain')
], MapSideBarPanelActions.prototype, "resetVisibility", null);
MapSideBarPanelActions = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            MapSideBarPanel: MapSideBarPanel_vue_1.default,
            List: bmk_ui_framework_1.List,
            ListItem: bmk_ui_framework_1.ListItem,
            Button: bmk_ui_framework_1.Button,
            ArrowRightIcon: bmk_ui_framework_1.ArrowRightIcon,
            ModalsSelectsModuleResults: ModalsSelectsModuleResults_vue_1.default,
            SwichQR: SwichQR_vue_1.default,
        },
    })
], MapSideBarPanelActions);
exports.default = MapSideBarPanelActions;
